import { css as litCss } from 'lit';
import { getTransformedTemplate } from '../transform-template';
import { transformCssTemplate } from './css-transform';
export function css(inputTemplateStrings, ...inputValues) {
    const transformedTemplate = getTransformedTemplate(inputTemplateStrings, inputValues, () => {
        return transformCssTemplate(inputTemplateStrings, inputValues);
    });
    const cssResult = litCss(transformedTemplate.strings, 
    /** The filter will remove the DeclarativeElement elements */
    ...transformedTemplate.values);
    return cssResult;
}
